import {GiftCategory} from "@/store/gift/types";
import {Tr} from "@/i18n/i18n";
import {Keys} from "@/constants/key";

export class GiftUtils {

    public static getAtlas(giftId: string): string {
        if (giftId.startsWith('east')) {
            return Keys.ATLAS_GIFTS_3;
        } else if (giftId.startsWith('val')) {
            return Keys.ATLAS_GIFTS_2;
        } else if (giftId.startsWith('spr')) {
            return Keys.ATLAS_GIFTS_4;
        } else if (giftId.startsWith('sep')) {
            return Keys.ATLAS_GIFTS_5;
        } else if (giftId.startsWith('hel')) {
            return Keys.ATLAS_GIFTS_6;
        } else if (giftId.startsWith('wom')) {
            return Keys.ATLAS_GIFTS_7;
        } else if (giftId.startsWith('birth')) {
            return Keys.ATLAS_GIFTS_8;
        } else if (giftId.startsWith('ny2025')) {
            return Keys.ATLAS_GIFTS_9;
        }
        return Keys.ATLAS_GIFTS;
    }

    public static getName(gc: GiftCategory): string {
        switch (gc) {
            case GiftCategory.FRUITS:
                return Tr('fr');
            case GiftCategory.NEW_YEAR:
                return Tr('ny');
            case GiftCategory.NY_2025:
                return '2025';
            case GiftCategory.VALENTINE:
                return Tr('val');
            case GiftCategory.FOOD:
                return Tr('food');
            case GiftCategory.ANIMALS:
                return Tr('ans');
            case GiftCategory.EASTER:
                return Tr('east');
            case GiftCategory.SPRING:
                return Tr('sprng');
            case GiftCategory.KNOWLEDGE_DAY:
                return Tr('knl.d');
            case GiftCategory.HELLOWEEN:
                return Tr('hlw');
            case GiftCategory.WOMAN:
                return Tr('8mr');
            case GiftCategory.BIRTHDAY:
                return Tr('brth');
        }
        return '';
    }
}
